import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

const ProductFilterModalEdit = (props) => {


    console.log(props.productFilterValue , 'props check filter modal')
    return (
        <div>
            <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Name</Form.Label>
                    <Form.Control type="text" onChange={(e) => props.setProductAddFilterEdit({...props.productAddFilterEdit, name: e.target.value})} value={props.productAddFilterEdit?.name || ''} />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Details</Form.Label>
                    <Form.Control type="text" onChange={(e) => props.setProductAddFilterEdit({...props.productAddFilterEdit, value: e.target.value})} value={props.productAddFilterEdit?.value || ''} />
                </Form.Group>
            </Form>
        </div>
    );
};

export default ProductFilterModalEdit;